<template>
  <div id="hcpDashboard">
    <hcp-getting-started-modal v-if="isHcpVerified" />
    <!--<hcp-slider-modules></hcp-slider-modules>-->
    <div class="content">
      <h1>Low Carb Program: Healthcare Professional Platform</h1>
      <mu-card class="downloads">
        <div class="mu-card-title-container">
          <div class="mu-card-title">
            Core Resources
            <!--<mu-flat-button
              label="View all"
              class="view-all"
              color="#0179d5"
              @click="goToResources()"
            />-->
          </div>
          <div class="mu-card-sub-title">
            Key information and guidance to support your patients
          </div>
        </div>
        <mu-card-text>
          <ul>
            <li v-for="download, downloadIndex in downloads.modules" :key="`download-${downloadIndex}`" v-if="!downloads.isLoading">
              <a :href="download.link" target="_blank" download>
                {{ download.title }}
                <mu-icon value="open_in_new" :size="16" color="#A8A8A8" />
              </a>
            </li>
            <li v-for="download, downloadIndex in 5" :key="`download-${downloadIndex}`" v-if="downloads.isLoading" style="margin: 15px 0 0;">
              <mu-linear-progress
                color="#d9d9d9"
                style="height:20px; width: 10%; background: #f1f1f1"
                v-bind:style="{width: getRandomArbitrary(15, 25)}"
              />
            </li>
          </ul>
        </mu-card-text>
      </mu-card>
      <mu-card class="commission">
        <mu-card-title title="Learn more about commissioning the program" />
        <mu-card-text>
          <mu-flat-button
            label="Contact Us"
            backgroundColor="#FFF"
            color="#0179d5"
            @click="goToFeedbackCommission"
          />
        </mu-card-text>
      </mu-card>
      <mu-card class="modules">
        <mu-card-title title="Professional Development" />
        <mu-card-text>
          <mu-row :gutter="true">
            <mu-col desktop="60" tablet="6" width="100">
              <mu-list class="links">
                <div class="linkWrap" v-for="link, index in quickLinks" :key="`link-${index}`">
                  <mu-list-item :title="link.label" @click.native="goTo(link.to, link.type)">
                    <div slot="left">
                      <mu-icon :value="link.icon" color="#0179d5" />
                    </div>
                  </mu-list-item>
                  <mu-divider />
                </div>
              </mu-list>
              <div class="recent">
                <h3 class="largeTitle blueTitle">Recently added</h3>
                <mu-list>
                  <mu-list-item class="item" v-for="post, index in recent.modules" :key="`post-${index}`" :title="post.post_title" :describeText="post.post_excerpt" disableRipple @click.native="goToModule(post.post_slug)" v-if="!recent.isLoading">
                    <div slot="leftAvatar">
                      <mu-avatar :src="post.post_video_thumb" />
                    </div>
                    <mu-divider />
                  </mu-list-item>
                  <mu-list-item v-for="post, index in 3" :key="`post-${index}`" v-if="recent.isLoading">
                    <div slot="leftAvatar">
                      <mu-avatar
                        :size="40"
                        backgroundColor="#F1F1F1"
                      />
                    </div>
                    <mu-linear-progress
                      slot="title"
                      color="#d9d9d9"
                      style="height:13px; width: 10%; background: #f1f1f1; position:relative; top: -5px;"
                      v-bind:style="{width: getRandomArbitrary(40, 60)}"
                    />
                    <mu-linear-progress
                      color="#d9d9d9"
                      style="height:13px; width: 10%; background: #f1f1f1;"
                      v-bind:style="{width: getRandomArbitrary(80, 100)}"
                    />
                  </mu-list-item>
                </mu-list>
              </div>
            </mu-col>
            <mu-col class="block-rcgp" desktop="40" tablet="40" width="100" style="background-image: url('static/hcp/rcgp-module.jpg')">
              <img class="rcgp-bg" src="static/hcp/rcgp-module.jpg" alt="RCGP" />
              <div class="rcgp-module">
                <div class="desc">
                  <img src="static/hcp/rcgp.png" alt="RCGP logo" class="rcgp-logo" />
                  <p class="title">{{quickLinks[1].label}}</p>
                  <p>Written by Dr David Unwin, this module describes the use of a low GI diet as an adjunct treatment for diabetes, using a case study of a real patient registered at the author's practice. The physiology and evidence behind a low glycaemic-index diet are described, as well as how to implement it in real life.</p>
                  <mu-flat-button
                    class="view"
                    label="View Module"
                    icon="play_circle_filled"
                    color="#FFF"
                    :href="quickLinks[1].to"
                    target="_blank"
                  />
                </div>
              </div>
            </mu-col>
          </mu-row>
        </mu-card-text>
      </mu-card>
      <mu-flexbox class="information" align="stretch">
        <mu-flexbox-item>
          <mu-row :gutter="true">
            <mu-col desktop="50" tablet="50" width="100">
              <mu-card>
                <mu-card-title title="Resources"></mu-card-title>
                <mu-card-text>
                  <md-chip class="cat" v-for="cat, index in cats.data" :key="`cat-${index}`" v-text="cat.name" @click.native="goToResourceCat(cat.slug)" v-if="!cats.isLoading"></md-chip>
                  <mu-linear-progress v-if="cats.isLoading" class="cat" v-for="cat, index in 5" :key="`cat-${index}`"
                    color="#d9d9d9"
                    style="display: inline-block; height:32px; width: 10%; background: #f1f1f1;"
                    v-bind:style="{width: getRandomArbitrary(10, 20)}"
                  />
                </mu-card-text>
              </mu-card>
            </mu-col>
            <mu-col class="feedback" style="background-image: url('static/hcp/hcp-feedback.jpg');" desktop="50" tablet="50" width="100">
              <div class="desc">
                <p class="title">Contact us</p>
                <p>Contact us to discuss your needs, queries and suggestions for development of the platform</p>
                <mu-flat-button
                  class="action"
                  label="Contact us"
                  icon="play_circle_filled"
                  color="#FFF"
                  @click.native="goToFeedback()"
                />
              </div>
            </mu-col>
          </mu-row>
        </mu-flexbox-item>
      </mu-flexbox>
      <mu-card class="forum">
        <mu-card-title title="Latest from the forum" />
        <mu-card-text>
          <hcp-forum :amount="5" />
        </mu-card-text>
      </mu-card>
      <!--<h2>Recently added</h2>
      <mu-flexbox class="posts" justify="flex-start" align="stretch">
        <mu-flexbox-item class="post" v-for="post, postIndex in recent.modules" :key="`post-${postIndex}`">
          <mu-card>
            <figure v-if="post.post_format === 'video'">
              <mu-circular-progress class="loader" :size="36"></mu-circular-progress>
              <router-link :to="'/hcp/article/' + post.post_slug">
                <img :src="post.post_video_thumb" />
              </router-link>
            </figure>
            <mu-card-text>
              <h3 class="title"><router-link :to="'/hcp/article/' + post.post_slug" v-text="post.post_title" /></h3>
              <div class="excerpt" v-text="post.post_video_desc"></div>
            </mu-card-text>
          </mu-card>
        </mu-flexbox-item>
      </mu-flexbox>
      <h2>You may like</h2>
      <mu-flexbox class="posts" justify="flex-start" align="stretch">
        <mu-flexbox-item class="post" v-for="post, postIndex in random.modules" :key="`post-${postIndex}`">
          <mu-card>
            <figure v-if="post.post_format === 'video'">
              <mu-circular-progress class="loader" :size="36"></mu-circular-progress>
              <router-link :to="'/hcp/article/' + post.post_slug">
                <img :src="post.post_video_thumb" />
              </router-link>
            </figure>
            <mu-card-text>
              <h3 class="title"><router-link :to="'/hcp/article/' + post.post_slug" v-text="post.post_title" /></h3>
              <div class="excerpt" v-text="post.post_video_desc"></div>
            </mu-card-text>
          </mu-card>
        </mu-flexbox-item>
      </mu-flexbox>-->
    </div>
  </div>
</template>
<script>
  import HcpMixin from '../../../mixins/HCPMixin';
  import HcpSliderModules from "../../HCP/SliderModules.vue";
  import HcpApi from '../../../api/Hcp';
  import HcpGettingStartedModal from "../../HCP/GettingStartedModal";
  import HcpForum from "../../HCP/LatestQuestions";
  import TitleManager from '../../../helpers/TitleManager';
  export default {
    components: {
      HcpForum,
      HcpGettingStartedModal,
      HcpSliderModules
    },
    mixins: [
      HcpMixin
    ],
    name: 'hcp-view',
    data() {
      return {
        downloads: {
          isLoading: true,
          modules: [],
        },
        recent: {
          isLoading: true,
          modules: [],
        },
        cats: {
          isLoading: true,
          data: []
        },
        quickLinks: [
          {
            label: 'Evidence and Papers',
            icon: 'chrome_reader_mode',
            to: 'evidence-and-papers',
            type: 'lifecat',
          },
          {
            label: 'RCGP eLearning Module',
            icon: 'book',
            to: 'https://www.lowcarbprogram.com/hcp/rcgp-module',
            type: 'link',
          },
          {
            label: 'Education',
            icon: 'school',
            to: 'HcpCategories',
            type: 'view',
          },
          /*{
            label: 'Articles',
            icon: 'assignment',
            to: 'LifeStyle',
            type: 'lifecat',
          },*/
        ]
      }
    },
    methods: {
      goToFeedbackCommission() {
        let self = this;
        self.$router.push({
          name: 'Contact',
          query: {
            commission: true
          }
        })
      },
      getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min) + '%'
      },
      goToResources() {
        let self = this;
        self.$router.push({
          name: 'Downloads'
        })
      },
      goToFeedback() {
        let self = this;
        self.$router.push({
          name: 'Contact'
        })
      },
      getFeaturedDownloads() {
        let self = this;
        HcpApi.getFeaturedDownloads().then(res => {
          self.downloads.modules = res.data;
          self.downloads.isLoading = false;
        });
      },
      getRecentModules() {
        let self = this;
        let params = {
          amount: 3,
          orderby: "date"
        };
        HcpApi.getModules($.param(params)).then(res => {
          self.recent.modules = res.data;
          self.recent.isLoading = false;
        });
      },
      getCats() {
        let self = this;
        HcpApi.getResourceCats().then(response => {
          self.cats.data = response.data;
          self.cats.isLoading = false;
        });
      },
      initMounted() {
       let self = this;
       self.getRecentModules();
       self.getFeaturedDownloads();
       self.getCats();
      },
      goToResourceCat(slug) {
        let self = this;
        self.$router.push({
          name: 'DownloadsCategory',
          params: {
            slug: slug
          }
        });
      },
      goToModule(slug) {
        let self = this;
        self.$router.push({
          name: 'HcpArticle',
          params: {
            slug: slug
          }
        })
      },
      goTo(link, type) {
        let self = this;
        if(type === 'link') {
          window.open(link, '_blank');
        } else if(type === 'lifecat') {
          self.$router.push({
            name: "LifeStyleCategory",
            params: {
              slug: link
            }
          })
        } else {
          self.$router.push({
            name: link
          })
        }
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
      if(self.isHcpVerified === false) {
        self.$router.push({
          name: 'HcpGettingStarted'
        })
      }
    }
  }
</script>
<style lang="less">
  @import "../../../styles/theme.less";
  #hcpDashboard {
    font-size: 15px;
    h1 {
      color: @primaryColor;
      margin: 8px 0 19px;
      line-height: 36px;
      @media only screen and (max-width: 1196px) {
        margin: 18px 24px;
      }
    }
    .loader {
      text-align: center;
    }
    .content {
      > .mu-card {
        margin: 0 0 24px;
      }
    }
    .mu-card {
      ul {
        padding: 0;
        list-style-type: none;
      }
      .mu-card-title-container {
        padding: 24px;
      }
      .mu-card-sub-title {
        font-size: 15px;
      }
      .mu-card-text {
        padding: 24px;
        padding-top: 0;
        font-size: 15px;
      }
    }
    .commission {
      color: #FFF;
      background-color: @primaryColor;
      .mu-card-title-container .mu-card-title {
        color: #FFF;
      }
    }
    .modules {
      position: relative;
      .block-rcgp {
        height: 100%;
        background: no-repeat center center;
        background-size: cover;
        position: absolute;
        top: 0;
        left: 61%;
        .rcgp-bg {
          width: 100%;
          height: auto;
          display: none;
        }
        @media only screen and (max-width: 992px) {
          width: 100%;
          background: none!important;
          margin: 24px 0 0;
          position: relative;
          left: 0;
          .rcgp-bg {
            display: block;
          }
        }
        &:before {
          width: 100%;
          height: 100%;
          content: '';
          background-color: fade(#000, 48%);
          position: absolute;
          left: 0;
          top: 0;
        }
        .rcgp-module {
          display: table;
          width: 100%;
          height: 100%;
          text-align: center;
          color: #FFF;
          position: absolute;
          top: 0;
          left: 0;
          @media only screen and (max-width: 992px) {
            position: static;
          }
          .rcgp-logo {
            width: 100%;
            height: auto;
            padding: 5px;
            background-color: #FFF;
            max-width: 170px;
            margin: 0 0 5px;
          }
          .title {
            margin: 0;
            font-size: 24px;
            font-weight: 500;
          }
          .desc {
            padding: 24px;
            display: table-cell;
            vertical-align: middle;
            line-height: 1.75;
            letter-spacing: 0.5px;
            position: relative;
            z-index: 1;
          }
          .view {
            margin: 8px 0 0;
            line-height: 22px;
            text-transform: capitalize;
            color: #FFF!important;
            background-color: fade(#FFF, 12%);
          }
        }
      }
    }
    .downloads {
      .view-all {
        margin: 0 0 0 30px;
        position: relative;
        top: -3px;
        border: 1px solid fade(#000, 12%);
      }
      .mu-card-title-container {
        padding-bottom: 8px;
        .mu-card-title {
          margin: 0 0 12px;
        }
      }
      li {
        margin: 0 0 12px;
        .mu-icon {
          position: relative;
          top: 3px;
        }
      }
    }
    .links {
      .mu-icon {
        position: relative;
        top: 2px;
      }
    }
    .recent {
      margin: 30px 0 0;
      h3 {
        margin: 0 0 10px;
        font-weight: 400;
      }
      .mu-list {
        margin: 0 -14px!important;
      }
      .item {
        .mu-item {
          padding-left: 132px;
          padding-bottom: 0;
        }
        .mu-avatar {
          width: 100px;
          height: 55px;
          position: relative;
          top: 10px;
          img {
            border-radius: 2px;
            box-shadow: none;
          }
        }
      }
      .mu-item-title {
        margin: 0 0 6px;
        font-size: 16px;
      }
      .mu-item-text {
        color: fade(#000, 60%)!important;
        margin-bottom: 16px;
        font-size: 15px;
        word-break: break-word;
      }
    }
    .information {
      margin-bottom: 24px;
      .cat {
        margin: 0 8px 8px 0;
        border-radius: 4px;
        font-size: 15px;
        color: @primaryColor;
        background-color: #C8E4FB;
        cursor: pointer;
      }
      .mu-card {
        height: 100%;
      }
      .feedback {
        padding: 24px;
        color: #FFF;
        background: no-repeat center center;
        background-size: cover;
        position: relative;
        &:before {
          width: 100%;
          height: 100%;
          content: '';
          background-color: fade(#000, 48%);
          position: absolute;
          top: 0;
          left: 0;
        }
        .desc {
          position: relative;
          .title {
            margin: 0;
            font-size: 24px;
            font-weight: 500;
          }
          .action {
            margin: 8px 0 0;
            line-height: 22px;
            text-transform: none;
            background-color: fade(#FFF, 12%);
          }
        }
      }
      .row {
        -webkit-align-items: stretch;
        align-items: stretch;
      }
    }
    h2 {
      margin: 0 0 26px;
      font-size: 24px;
      font-weight: 500;
      color: @primaryColor;
      ~ h2 {
        margin-top: 8px;
      }
    }
    .post {
      margin-bottom: 16px;
      figure {
        margin: 0;
        position: relative;
        background: #E2F0FA;
        padding-bottom: 56.25%;
        height: 0;
        iframe {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
        }
      }
      img {
        width: 100%;
        height: auto;
        position: relative;
        z-index: 9;
      }
      .loader {
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        position: absolute;
        top: 50%;
        left: 50%;
      }
      .mu-card {
        height: 100%;
      }
      .title {
        line-height: 26px;
        margin: 0 0 13px;
        font-size: 18px;
        font-weight: 500;
        color: @primaryColor;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .excerpt {
        font-size: 15px;
        color: #000;
      }
    }
  }
  /*@media only screen and (max-width: 768px) {
    #hcpDashboard {
      .mu-flex-row {
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
      }
      .post {
        flex: 0 1 100%!important;
        width: 100%;
        margin-left: 0!important;
      }
    }
  }*/
</style>



// WEBPACK FOOTER //
// HCP.vue?5f8e4e10